import actionCreatorFactory from 'typescript-fsa';

const ac = actionCreatorFactory();

export default {
  showLeftMenu: ac('showLeftMenu'),
};
